export const en = {
    'icon-title': 'Recommendations',
    'popup-title': 'Recommendations'
};
